import React from "react";
import { string } from "yup";
import Input from "./Base";
import InputMaskWithRef from "./InputMaskWithRef";
const ssnRegex = /^(X{3}|\d{3})-?(X{2}|\d{2})-?(X{4}|\d{4})$/;
const ssnMask = [/(\d|X)/, /(\d|X)/, /(\d|X)/, "-", /(\d|X)/, /(\d|X)/, "-", /(\d|X)/, /(\d|X)/, /(\d|X)/, /(\d|X)/];
export const schema = string().required("A Social Security number is required.").matches(ssnRegex, "Please enter a valid Social Security number.");
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Social Security Number",
  InputComponent: InputMaskWithRef,
  required: true,
  mask: ssnMask,
  maskInputValue: true,
  inputMode: "numeric",
  ...props
}));
